import React from 'react'
import { connect } from 'react-redux'
import { AppState, Dispatcher, RootState } from 'AppTypes'

import { toggleMainAppSidebarOpen } from '@app/state_management/actions'

import { Button } from '@share/components'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const ToggleMainMenuButton: React.FC<Props> = ({
  appState: {
    isMainAppSidebarOpen
  },
  dispatch
}) => {
  const dispatchToggleMainAppSidebarOpen = () => dispatch(toggleMainAppSidebarOpen(!isMainAppSidebarOpen))
  return (
    <Button
      id="sidebarCollapse"
      className="btn btn-light"
      onClick={dispatchToggleMainAppSidebarOpen}
    >
      <i className="fas fa-bars">{' '}</i>
    </Button>
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(ToggleMainMenuButton)
